import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import Header from '../containers/Header'
import Footer from '../containers/Footer'
import { Box } from '@material-ui/core'

const Layout = ({ children, isMobileView, loading, matchProps, ...rest }) => {
  return <Fragment>{children}</Fragment>
}

class DefaultLayout extends React.Component {

  render() {
    const { component: Component, loading, isSignedInUser, ...rest } = this.props
    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout loading={loading} matchProps={matchProps}>
            <Header isSignedInUser={isSignedInUser} />
            <Box flexGrow="1" minHeight='calc(100vh - 114px)'>
              <Component {...matchProps} />
            </Box>
            <Footer />
          </ Layout>
        )}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth
  return { authUser }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)
